"use client"

import { useEffect, useRef } from "react"
import { incrementViewAction } from "@/actions/view/view.action"
import type { EntityType } from "@/app/types"

const incrementedEntityIds = new Set<string>()

export function useEntityViewIncrement(
  entityId?: string | null,
  entityType: EntityType = "product"
) {
  const hasFiredRef = useRef(false)

  useEffect(() => {
    if (!entityId) return
    if (typeof window === "undefined") return
    if (hasFiredRef.current) return

    if (incrementedEntityIds.has(entityId)) return
    incrementedEntityIds.add(entityId)

    hasFiredRef.current = true
    void incrementViewAction(entityType, entityId).catch(() => null)
  }, [entityId, entityType])
}
